import { Sidebar } from '@/shared/components/ui/sidebar'
import { getStoryFromFirestore, syncScriptWithFirebaseStory } from '@/service/firestore'
import React from 'react'
import { useAuth } from '@/features/auth'
import { NavItemsSimple } from '@/components/custom/nav-Items-simple'
import { setJsonScriptEditor } from '@/features/screenplay/components/editor/utils/JsonUtils'
import { useWorkspace } from '@/features/workspace'
import { WorkspaceSidebarScaffold } from '@/features/workspace'
import { stData } from './editor/stories/stData'
import { useStoryStore } from '@/features/shared/stores/story.store'
import { handleDownload } from './editor/utils/utils'

const StEditorSidebar = ({ ...props }: React.ComponentProps<typeof Sidebar>) => {
    const { project } = useWorkspace()
    const { editor } = useStoryStore()
    const { user } = useAuth()
    const authorName = user?.displayName || user?.name || 'Unknown'

    const subMenuData = [
        ...(import.meta.env.DEV ? [{
            name: 'Load Json',
            emoji: '📥',
            onClick: async () => {
                console.log('syncing')

                const data = stData
                setJsonScriptEditor(editor, data ?? [])
            },
        }, {
            name: 'Sync Script Down',
            emoji: '🔄',
            onClick: async () => {
                console.log('syncing')

                const data = await getStoryFromFirestore(user!.uid, project!.id)
                console.log('>>', data)
                setJsonScriptEditor(editor, data?.content ?? [])
            },
        },
        {
            name: 'Upload to Database',
            emoji: '📤',
            onClick: async () => {
                syncScriptWithFirebaseStory(user!.uid, project!.id)
            },
        },] : []),

        {
            name: 'Download PDF',
            emoji: '📄',
            onClick: () => {
                if (editor) {
                    handleDownload(project?.title || "Story", editor, authorName)
                } else {
                    console.error("Editor instance missing for Story export")
                }
            },
        },
    ]
    return (
        <WorkspaceSidebarScaffold>
            {subMenuData.length !== 0 && (
                <NavItemsSimple navItems={subMenuData} header={{ title: 'Options' }} />
            )}
        </WorkspaceSidebarScaffold>
    )
}

export default StEditorSidebar
